import { ChangeEvent, Fragment } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router";

import { PageHeader } from "@dzambalaorg/mui-page-layout";
import { useUser } from "@dzambalaorg/provider-user";
import { UserRole } from "@framework/types";
import { Tabs } from "@dzambalaorg/ui-kit";

import { MerchantTabs } from "./tabs";
import { MerchantGeneral } from "./general";
import { MerchantManagers } from "./managers";
import { MerchantInvitations } from "./invitations";
import { MerchantSettings } from "./settings";

export const Merchant = () => {
  const { tab = MerchantTabs.general } = useParams<{ tab: MerchantTabs }>();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { profile } = useUser<any>();

  const handleChange = (_event: ChangeEvent<any>, newValue: MerchantTabs): void => {
    void navigate(`/merchant/${newValue === MerchantTabs.general ? "" : newValue}`);
  };

  return (
    <Fragment>
      <PageHeader message="pages.merchant.title" />

      <Tabs value={tab} indicatorColor="primary" textColor="primary" onChange={handleChange} sx={{ mb: 2 }}>
        {Object.values(MerchantTabs).map(tab => (
          <Tabs.Tab key={tab} label={formatMessage({ id: `pages.merchant.tabs.${tab}` })} value={tab} />
        ))}
      </Tabs>
      <MerchantGeneral open={tab === MerchantTabs.general} />
      <MerchantManagers open={tab === MerchantTabs.managers} />
      <MerchantInvitations open={tab === MerchantTabs.invitations} />
      {profile.userRoles.includes(UserRole.SUPER) && <MerchantSettings open={tab === MerchantTabs.settings} />}
    </Fragment>
  );
};
